import { removeCookie } from './../utils/cookie';
import type { lang } from "moment";

interface CartItem {
  name: string;
  price: string;
  image: string;
}

export default class AbandonCart {
  private originalTitle: string;
  private lastCartUpdate: number;
  private popupCount: number;
  private sessionPopupCount: number;
  private readonly maxSessionPopups: number = 2;
  private readonly maxCookiePopups: number = 4;
  private readonly popupCookieName: string = 'kts_popupCount';
  private readonly sessionPopupCookieName: string = 'kts_sessionPopupCount';
  private readonly reminderDelay: number = 15 * 60 * 1000; // 15 minutes
  private readonly displayDuration: number = 15 * 1000; // 15 seconds
  // private readonly reminderDelay: number = 1000;
  // private readonly displayDuration: number = 20 * 600 * 1000;
  private readonly hoverExtension: number = 5000;
  private popupTimers: number[] = [];


  constructor() {
    this.originalTitle = document.title;
    this.lastCartUpdate = parseInt(this.getCookie('kts_lastCartUpdate') || '0');
    this.popupCount = parseInt(this.getCookie(this.popupCookieName) || '0');
    this.sessionPopupCount = parseInt(this.getCookie(this.sessionPopupCookieName) || '0');
  }

  private setStorageItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error('Local storage is not available:', e);
    }
  }

  private getStorageItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error('Local storage is not available:', e);
      return null;
    }
  }

  private removeStorageItem(key: string): string | null {
    try {
      return localStorage.removeItem(key);
    } catch (e) {
      console.error('Local storage is not available:', e);
      return null;
    }
  }

  private setCookie(name: string, value: string, days?: number): void {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  private getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  private removeCookie(name: string) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  public updateCartTime(): void {
    this.lastCartUpdate = new Date().getTime();
    this.setCookie('kts_lastCartUpdate', this.lastCartUpdate.toString());

    this.popupTimers.forEach(timer => clearTimeout(timer));
    this.popupTimers = [];

    this.setReminderTimer();
  }

  private setReminderTimer(): void {
    const cartItems = this.getCartContents();
    if (cartItems.length === 0) return;

    this.popupTimers.forEach(timer => clearTimeout(timer));
    this.popupTimers = [];

    if (!this.isCartOrCheckoutPage()) {
      this.popupTimers.push(window.setTimeout(() => {
        this.showReminderPopup(cartItems);
      }, this.reminderDelay));
    }
  }

  private initReminderTimer(remainingTime: number): void {
    const cartItems = this.getCartContents();
    if (cartItems.length === 0) return;

    this.popupTimers.forEach(timer => clearTimeout(timer));
    this.popupTimers = [];

    if (!this.isCartOrCheckoutPage()) {
      this.popupTimers.push(window.setTimeout(() => {
        this.showReminderPopup(cartItems);
      }, remainingTime));
    }    
  }

  private getTotalItems() {
    var miniCartItems = document.querySelector(".alt-cart-indicator");
    if (miniCartItems){
        var totalItems = miniCartItems.innerHTML;
        return Number(totalItems);
    }
    return 0;
  }
  private showReminderPopup(cartItems: CartItem[]): void {
    if (this.sessionPopupCount >= this.maxSessionPopups || this.popupCount >= this.maxCookiePopups) return;
    let currentTime = new Date().getTime();
    let timeSinceLastCartUpdate = currentTime - this.lastCartUpdate;
    // if (timeSinceLastCartUpdate >= this.reminderDelay && !document.body.classList.contains("single-product__main")) {
    if (timeSinceLastCartUpdate >= this.reminderDelay && !document.getElementById("product")) {
      var totalItems = this.getTotalItems();
      document.title = `(${totalItems}) items in your cart | ${this.originalTitle}`;

      let popup = document.createElement("div");
      popup.classList.add("abandon-cart__popup");
      popup.innerHTML = `<h4 class="abandon-cart__popup-title">You left (${totalItems}) items in your cart!</h4>`;

      // Show maximum 2 items when click popup on mobile
      if (window.innerWidth <= 768){
        popup.addEventListener("click", () => {
            popup.classList.add("active");
        });
      }

      let popupItems = document.createElement("div");
      popupItems.classList.add("abandon-cart__popup-items");

      cartItems.forEach((cartItem) => {
          let item = document.createElement("div");
          item.classList.add("abandon-cart__item");
          item.innerHTML = `<img src="${cartItem.image}" class="abandon-cart__item-img"><div class="abandon-cart__item-details"><p class="abandon-cart__item-name">${cartItem.name}</p><div class="abandon-cart__item-price">${cartItem.price}</div></div>`;
          popupItems.appendChild(item);
      });

      popup.appendChild(popupItems);
      
      var customClass = '';
      if (totalItems <= 2){
        customClass = 'abandon-cart__hidden';
      }
      let popupFooter = document.createElement("div");
      popupFooter.classList.add("abandon-cart__popup-footer");
      popupFooter.innerHTML = `<a href="/cart/" class="abandon-cart__popup-viewall ${customClass}">View all</a><a href="/cart/"><span>View Cart</span></a><a href="/checkout/"><span>Checkout Now</span></a>`;
      popup.appendChild(popupFooter);

      let closeBtn = document.createElement("span");
      closeBtn.classList.add("abandon-cart__close");
      closeBtn.textContent = "×";
      closeBtn.addEventListener('click', () => {
          popup.remove();
          this.setStorageItem('kts_lastPopupClose', currentTime);
          document.title = this.originalTitle;
      });

      popup.appendChild(closeBtn);
      document.body.appendChild(popup);

      let hideTimeout = setTimeout(() => {
          popup.classList.add("abandon-cart__fade-out");
          popup.addEventListener('transitionend', () => {
              popup.remove();
          });
          document.title = this.originalTitle;
      }, this.displayDuration);

      popup.addEventListener('mouseover', () => clearTimeout(hideTimeout));
      popup.addEventListener('mouseout', () => {
          hideTimeout = setTimeout(() => {
              popup.classList.add('abandon-cart__fade-out');
              popup.addEventListener('transitionend', () => {
                  popup.remove();
              });
              document.title = this.originalTitle;
          }, this.hoverExtension);
      });

      this.sessionPopupCount++;
      this.popupCount++;
      this.setCookie(this.sessionPopupCookieName, this.sessionPopupCount);
      this.setCookie(this.popupCookieName, this.popupCount, 7);
      this.removeCookie('kts_lastCartUpdate');
      this.removeStorageItem("kts_leaveCart");
    }
  }
  public showWelcomeBackPopup(totalItems: number): void {
    if (this.getCookie('kts_welcomeBackShown')) return;
    if (!this.getCartContents().length){
      this.setCookie('kts_welcomeBackShown', 'true');;
      return;
    }
    this.setCookie('kts_welcomeBackShown', 'true');

    let popup = document.createElement("div");
    popup.classList.add("abandon-cart__popup");
    popup.classList.add("abandon-cart__popup-welcome");
    popup.innerHTML = `<h4 class="abandon-cart__popup-title">Welcome back! We saved your cart (${totalItems}) for you.</h4>`;

    // Show maximum 2 items when click popup on mobile
    if (window.innerWidth <= 768){
      popup.addEventListener("click", () => {
        popup.classList.add("active");
      });
    }

    let popupItems = document.createElement("div");
    popupItems.classList.add("abandon-cart__popup-items");

    const cartItems = this.getCartContents();
    cartItems.forEach((cartItem) => {
        let item = document.createElement("div");
        item.classList.add("abandon-cart__item");
        item.innerHTML = `<img src="${cartItem.image}" class="abandon-cart__item-img"><div class="abandon-cart__item-details"><p class="abandon-cart__item-name">${cartItem.name}</p><div class="abandon-cart__item-price">${cartItem.price}</div></div>`;
        popupItems.appendChild(item);
    });

    popup.appendChild(popupItems);

    var customClass = '';
    if (totalItems <= 2){
      customClass = 'abandon-cart__hidden';
    }
    let popupFooter = document.createElement("div");
    popupFooter.classList.add("abandon-cart__popup-footer");
    popupFooter.innerHTML = `<a href="/cart/" class="abandon-cart__popup-viewall ${customClass}">View all</a><a href="/cart/"><span>View Cart</span></a><a href="/checkout/"><span>Checkout Now</span></a>`;
    popup.appendChild(popupFooter);
    
    let closeBtn = document.createElement("span");
    closeBtn.classList.add("abandon-cart__close");
    closeBtn.textContent = "×";
    closeBtn.addEventListener('click', () => {
        popup.remove();
    });

    popup.appendChild(closeBtn);
    document.body.appendChild(popup);
    
    // let hideTimeout = setTimeout(() => {
    //     popup.classList.add("abandon-cart__fade-out");
    //     popup.addEventListener('transitionend', () => {
    //         popup.remove();
    //     });
    // }, this.displayDuration);

    // popup.addEventListener('mouseover', () => clearTimeout(hideTimeout));
    // popup.addEventListener('mouseout', () => {
    //     hideTimeout = setTimeout(() => {
    //         popup.classList.add('abandon-cart__fade-out');
    //         popup.addEventListener('transitionend', () => {
    //             popup.remove();
    //         });
    //     }, this.hoverExtension);
    // });
  }

  public getCartContents(): CartItem[] {
    const items = document.querySelectorAll("li.woocommerce-mini-cart-item");
    const cartItems: CartItem[] = [];
    items.forEach((item, index) => {
      if (index <= 1) {
        const itemName = (item.querySelector("p.item-title")?.innerHTML || "");
        const itemPriceHTML = (item.querySelector(".minicart-product-price")?.innerHTML || "");
        const itemImg = (item.querySelector(".alt-minicart-thumbnail span.thumbnail")?.getAttribute("data-image") || "");
        cartItems.push({ name: itemName, price: itemPriceHTML, image: itemImg });
      }
    });
    return cartItems;
  }

  public checkInitialState(): void {
    // var leaveCart = this.getStorageItem('kts_leaveCart');
    // if (leaveCart == "yes") {
    //   this.setReminderTimer();
    // }else{
      var lastCartUpdate: number = Number(this.getCookie('kts_lastCartUpdate'));
      // if (lastCartUpdate && !document.body.classList.contains("single-product")) {
      if (lastCartUpdate && !document.getElementById("product")) {
        var currentTime = new Date().getTime();
        var elapsedTime = currentTime - lastCartUpdate;
        var remainingTime = this.reminderDelay - elapsedTime;
        
        if (remainingTime > 0) {
          this.initReminderTimer(remainingTime);
        }
      }
    // }
  }

  private setupStorageListener(): void {
    window.addEventListener('storage', (event) => {
      if (event.key === 'kts_lastCartUpdate') {
        this.lastCartUpdate = parseInt(event.newValue || '0');

        this.popupTimers.forEach(timer => clearTimeout(timer));
        this.popupTimers = [];
        this.setReminderTimer();
      } else if (event.key === 'kts_popupCount') {
        this.popupCount = parseInt(event.newValue || '0');
      }
    });
  }

  private setupEventListeners(): void {
    document.addEventListener("click", (event) => {
      const target = event.target as HTMLElement;
      if (target.closest(".single_add_to_cart_button") ||
          target.closest(".fake-add-to-cart")) {
        this.updateCartTime();
      }
      if (target.closest(".quantity__container")) {
        this.updateCartTime();
      }
      if (target.closest(".alt_remove_cart_button")) {
        this.updateCartTime();
      }
      if (target.closest(".minicart-bottom__coupon-action")) {
        this.updateCartTime();
      }
      if (target.closest(".oaps-pwp__item-atc")) {
        this.updateCartTime();
      }
    });

    window.addEventListener('beforeunload', () => {
      if (this.isCartOrCheckoutPage()) {
        this.setStorageItem('kts_leaveCart', "yes");
        this.updateCartTime();
      }
    });
  }
  public isCartOrCheckoutPage(): boolean {
    const cartContainer = document.querySelector('.shopping-cart-containers');
    return (cartContainer !== null || document.body.classList.contains('woocommerce-cart') || 
    document.body.classList.contains('woocommerce-checkout'))
  }

  public init(): void {
    // console.log('init Abandon Cart');

    this.setupEventListeners();
    this.setupStorageListener();
  }
}
